import "@fortawesome/fontawesome-free/css/all.min.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css"; // core PrimeReact CSS
import "./styles/freya/layout.scss";
import "./styles/freya/theme/theme-dark/turquoise/theme.scss";
import "./App.css";
import "./app2.css";
import "/node_modules/flag-icons/css/flag-icons.min.css";

import * as ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { store } from "./redux/store";
// import loadable from '@loadable/component';
//MENE: import { I18nProvider } from '@slone/ui-fabric-i18n'; removed from the render <Provider store={store}> <I18nProvider><UiToolkitProvider>
import {
  ConfirmDialogProvider,
  ToastProvider,
  UiToolkitProvider,
} from "@sl/react-datafabric-components";
import ErrorPage from "./common/app/error/page";
import { ErrorBoundary } from "./common/components/error-boundary/index";
import { router } from "./router";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

function isEnvFlagEnabled(value: unknown): boolean {
  if (typeof value !== "string") return false;
  const normalized = value.trim().toLowerCase();
  return (
    normalized === "true" ||
    normalized === "1" ||
    normalized === "yes" ||
    normalized === "on"
  );
}

async function disableMockingIfRegistered() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }

  const registrations = await navigator.serviceWorker.getRegistrations();
  await Promise.all(
    registrations
      .filter((registration) =>
        registration.active?.scriptURL?.includes("mockServiceWorker.js")
      )
      .map((registration) => registration.unregister())
  );
}

async function enableMocking() {
  const shouldEnableMocking = isEnvFlagEnabled(import.meta.env.VITE_MOCK_PORTAL);

  if (!shouldEnableMocking) {
    await disableMockingIfRegistered();
    return;
  }

  const { serviceWorker } = await import("../mocks/browser");
  return serviceWorker.start({ onUnhandledRequest: "bypass" });
}

enableMocking().then(() => {
  root.render(
    <ErrorBoundary fallback={<ErrorPage />}>
      <link rel="stylesheet" href="./app.css" />
      {/* font for auth pages */}
      <link
        href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap"
        rel="stylesheet"
      />

      <Provider store={store}>
        <UiToolkitProvider>
          <ToastProvider>
            <ConfirmDialogProvider>
              <ErrorBoundary fallback={<ErrorPage />}>
                <RouterProvider router={router} />
              </ErrorBoundary>
            </ConfirmDialogProvider>
          </ToastProvider>
        </UiToolkitProvider>
      </Provider>
    </ErrorBoundary>
  );
});
